module.exports = __webpack_public_path__ + "img/GM4000QCI.65038200.jpg";